import { MatchHeight } from 'js-match-height';

const selectors = {
  titles: '.article-block__content .title'
};

export default function init ({ el, context }) {
  const matchHeight = new MatchHeight(selectors.titles);
}